import { fromArrayBuffer } from 'geotiff';
import { cloneDeep } from 'lodash';
import turf from '@turf/turf';

import { readDTMFile } from '../../api/Projects/server/project-methods-server';

/**
 * @typedef {object} GeoJSON
 */

/**
 * Gets the elevation of a point given its coordinates.
 *
 * @param {number[]} coordinates - The coordintaes of the point to get elevation [longitude,latitude,?altitude].
 * @param {number[]} boundingBox - The bounding box for the tiff [xmin, ymin, xmax, ymax].
 * @param {number} height - The height of the tiff.
 * @param {number} width - The width of the tiff.
 * @param {number[]} elevationArray - The elevation map in one dimension.
 * @returns {number} The elevation for that position, if altitude has no data returns -999.
 */
const getElevation = (coordinates, boundingBox, height, width, elevationArray) => {
  const [lon, lat] = coordinates;
  const [xmin, ymin, xmax, ymax] = boundingBox;
  /* TODO: implementation */
  const x = Math.round(((lon - xmin) * (width - 1)) / (xmax - xmin));
  let y = Math.round(((lat - ymin) * (height - 1)) / (ymax - ymin));
  // FIXME: si algo va mal preguntar por Hector
  // inversión de coordenadas, ya que el array empieza por arriba
  y = height - y - 1;
  const index = y * width + x;
  return elevationArray[index];
};

const getArrayBufferFromBuffer = inputbuffer => {
  if (inputbuffer.length === inputbuffer.buffer.byteLength) return inputbuffer.buffer;
  // else:
  // You may use the `byteLength` property instead of the `length` one.
  return inputbuffer.subarray(0, inputbuffer.length);
};

/**
 * Gets the elevation for all the points in the feature collection.
 *
 * @param {GeoJSON} geojson - A geojson Object.
 * @param {string} projectId - The project id to get the dtm file.
 * @returns {GeoJSON} The same geojson with the elevation added as a 3rd coordinate.
 * @throws Error if something goes wrong in the functions used.
 */
export default async (geojson, projectId) => {
  try {
    const dtmFile = await readDTMFile(projectId);
    const readGeotiff = await fromArrayBuffer(getArrayBufferFromBuffer(dtmFile));
    const image = await readGeotiff.getImage();
    const boundingBox = image.getBoundingBox();
    const height = image.getHeight();
    const width = image.getWidth();
    const data = await image.readRasters();
    const elevationArray = data[0];

    const geojsonWithElevation = cloneDeep(geojson);
    turf.coordEach(geojsonWithElevation, currentCoord => {
      const elevationForPosition = getElevation(
        currentCoord,
        boundingBox,
        height,
        width,
        elevationArray
      );
      // FIXME: should we account for errors in DTM ??
      currentCoord[2] = elevationForPosition; // eslint-disable-line
    });
    return geojsonWithElevation;
  } catch (error) {
    throw new Error(error.message);
  }
};
